import React from 'react';
import { Badge } from '@atoms';

export interface PermissionStatusBadgeProps {
  isActive: boolean;
}

export const PermissionStatusBadge: React.FC<PermissionStatusBadgeProps> = ({ isActive }) => {
  return (
    <Badge
      variant={isActive ? 'success' : 'error'}
      size="sm"
    >
      {isActive ? 'Active' : 'Inactive'}
    </Badge>
  );
};
